import React from "react";
import A1 from "./A1";
import { MODE } from "./util";

export default ({ onComplete = () => {} }) => {
  return <A1 mode={MODE.upper} onComplete={onComplete} />;
};
